export * from './app-sidebar-header.component';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-sidebar-header/index.ts